import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { useState }  from 'react';
import { Modal } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { useForm, Controller } from 'react-hook-form'
import { BsPencil } from "react-icons/bs";

import { fetchElencoQuestionari } from 'features-csvc/reduxStore/elencoQuestionariSlice';
import { creaNuovoQuestionario } from 'features-csvc/reduxStore/elencoQuestionariSlice'


import { setPartnerPannelloEtQuestionario } from 'features-csvc/reduxStore/menuConfigSlice';
import { setQuestionarioCorrente } from 'features-csvc/reduxStore/questCorrenteSlice';
/*
import {
  setQuestionarioMenu,
  unsetQuestionarioMenu
} from 'features-csvc/reduxStore/siteMapsSlice';
*/
import { useDispatch, useSelector } from 'react-redux';

function generaPassword() {
    const parole = [
      "Abbi", "Abbo", "Abri", "Abro", "Acca", "Acce", "Acci", "Acid", "Acie", "Acme", "Acmi", "Acne", "Acni", "Acra", "Acre", 
      "Acri", "Acro", "Acta", "Acui", "Adda", "Addi", "Addo", "Adii", "Adsl", "Aedi", "Aedo", "Aera", "Aere", "Aeri", "Aero", 
      "Affa", "Affe", "Afni", "Afra", "Afre", "Afri", "Afro", "Afta", "Afte", "Agar", "Aggi", "Agha", "Aghi", "Agia", "Agii", 
      "Agio", "Agli", "Agna", "Agne", "Agni", "Agno", "Agra", "Agre", "Agri", "Agro", "Ahia", "Aids", "Aime", "Aira", "Aire", 
      "Airi", "Aita", "Aite", "Aiti", "Aito", "Alai", "Alba", "Albe", "Albi", "Albo", "Alca", "Alce", "Alci", "Aldi", "Alea", 
      "Alee", "Alef", "Alfa", "Alfe", "Alga", "Alia", "Alio", "Alla", "Alle", "Allo", "Alma", "Alme", "Almi", "Almo", "Alni", 
      "Alno", "Aloe", "Alpe", "Alpi", "Alse", "Alsi", "Alta", "Alte", "Alti", "Alto", "Alvi", "Alvo", "Alza", "Alzi", "Alzo", 
      "Amai", "Amba", "Ambe", "Ambi", "Ambo", "Amen", "Amni", "Amok", "Ampi", "Anca", "Ance", "Anco", "Anda", "Ande", "Ando", 
      "Ange", "Anni", "Anno", "Ansa", "Anse", "Ansi", "Anso", "Anta", "Ante", "Anzi", "Aoni", "Apii", "Apio", "Appi", "Appo", 
      "Apra", "Apre", "Apri", "Apro", "Aqua", "Aque", "Arac", "Arai", "Arak", "Arca", "Arce", "Arci", "Arco", "Arda", "Arde", 
      "Ardi", "Ardo", "Area", "Aree", "Arei", "Arem", "Areo", "Argo", "Aria", "Arie", "Arii", "Ario", "Arma", "Arme", "Armi", 
      "Armo", "Arpa", "Arpe", "Arra", "Arre", "Arri", "Arsa", "Arse", "Arsi", "Arso", "Arta", "Arte", "Arti", "Arto", "Arva", 
      "Asce", "Asci", "Asco", "Asma", "Asme", "Asmi", "Aspa", "Aspe", "Aspi", "Aspo", "Asse", "Assi", "Asso", "Asta", "Aste", 
      "Asti", "Atai", "Atea", "Atee", "Ates", "Atet", "Atra", "Atre", "Atri", "Atro", "Atta", "Atte", "Atti", "Atto", "Aude", 
      "Audi", "Audo", "Auff", "Auge", "Aula", "Aule", "Auna", "Aune", "Auni", "Auno", "Aura", "Aure", "Auri", "Auro", "Ausa", 
      "Ause", "Ausi", "Auso", "Auta", "Aute", "Auti", "Auto", "Avea", "Avio", "Avra", "Avro", "Axel", "Azza", "Azze", "Baba", 
      "Babe", "Baby", "Baca", "Baci", "Baco", "Bada", "Bade", "Badi", "Bado", "Baga", "Baht", "Baia", "Baie", "Baio", "Bali", 
      "Band", "Bang", "Bani", "Bano", "Bara", "Bare", "Bari", "Barn", "Baro", "Basa", "Base", "Basi", "Baso", "Baud", "Bava", 
      "Bave", "Beai", "Bear", "Beat", "Bebe", "Beca", "Beco", "Been", "Beep", "Bega", "Bela", "Beli", "Belo", "Bema", "Bene", 
      "Beng", "Beni", "Bere", "Beri", "Berk", "Beta", "Beva", "Beve", "Bevi", "Bevo", "Bica", "Bici", "Bide", "Biga", "Bige", 
      "Bigi", "Bigo", "Bile", "Bili", "Bina", "Bine", "Bini", "Bino", "Bios", "Biot", "Biro", "Bite", "Bivi", "Blah", "Bleu", 
      "Blob", "Blog", "Boba", "Bobe", "Boce", "Boci", "Body", "Boga", "Boia", "Bold", "Boli", "Bolo", "Boma", "Bome", "Bomi", 
      "Bona", "Bond", "Bone", "Boni", "Bono", "Book", "Boom", "Bora", "Bore", "Bori", "Boro", "Bort", "Bosa", "Bose", "Boss", 
      "Bota", "Bote", "Boti", "Boto", "Bove", "Bovi", "Bovo", "Boxa", "Boxe", "Boxi", "Boxo", "Brai", "Bric", "Brie", "Brii", 
      "Brik", "Brio", "Brui", "Brum", "Brut", "Bubu", "Buca", "Buci", "Buco", "Bufa", "Bufi", "Bufo", "Buge", "Bugi", "Buia", 
      "Buie", "Buio", "Bula", "Bule", "Buli", "Bull", "Bulo", "Buna", "Bune", "Buoi", "Buon", "Bura", "Bure", "Buri", "Buro", 
      "Busa", "Buse", "Busi", "Buso", "Buuu", "Byte", "Caca", "Caci", "Caco", "Cada", "Cade", "Cadi", "Cado", "Cady", "Caga", 
      "Cago", "Caia", "Caid", "Caie", "Caio", "Cake", "Cala", "Cale", "Cali", "Call", "Calo", "Cami", "Camo", "Camp", "Cana", 
      "Cane", "Cani", "Cano", "Caos", "Capa", "Cape", "Capi", "Capo", "Cara", "Card", "Care", "Cari", "Caro", "Casa", "Case", 
      "Cash", "Casi", "Caso", "Cast", "Cava", "Cave", "Cavi", "Cavo", "Cebi", "Cebo", "Ceca", "Cece", "Ceci", "Ceco", "Ceda", 
      "Cede", "Cedi", "Cedo", "Cefi", "Cefo", "Ceka", "Ceke", "Ceki", "Ceko", "Cela", "Celi", "Celo", "Cena", "Cene", "Ceni", 
      "Ceno", "Cent", "Cera", "Cere", "Ceri", "Cero", "Cesi", "Ceti", "Ceto", "Chat", "Ched", "Chef", "Chic", "Chip", "Chiu", 
      "Choc", "Chou", "Ciac", "Ciaf", "Ciak", "Ciao", "Ciba", "Cibi", "Cibo", "Cica", "Cidi", "Cima", "Cime", "Cimi", "Cimo", 
      "Cine", "Cinz", "Cioe", "Cire", "Ciro", "Cisi", "Cita", "Citi", "Cito", "City", "Ciuf", "Cive", "Civi", "Clan", "Clap", 
      "Clic", "Clip", "Clof", "Clop", "Clou", "Club"]
    const numeri = "123456789";
    const simboli = "!#$%&*?";
    
    let password = "";
    password += parole[Math.floor(Math.random() * parole.length)]
    password += simboli[Math.floor(Math.random() * simboli.length)];
    password += numeri[Math.floor(Math.random() * numeri.length)]
    password += parole[Math.floor(Math.random() * parole.length)]
    password += parole[Math.floor(Math.random() * parole.length)]

    return password.slice(0, 12)
  }
  

  const validatePassword = (value) => {
    const errors = [];
    if (value.length < 8 || value.length > 64) {
      errors.push('La password deve essere tra 8 e 64 caratteri.');
    }
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const validClasses = [hasUpperCase, hasLowerCase, hasNumber, hasSymbol].filter(Boolean).length;
  
    if (validClasses < 3) {
      errors.push('La password deve contenere almeno 3 delle seguenti classi di caratteri: lettere maiuscole, lettere minuscole, numeri, simboli.');
    }
  
    return errors.length ? errors.join(' ') : true;
  };

// import Process from 'components/pages/landing/Process';

// import dotenv from 'dotenv'     // modulo per gestire il file .env per le variabili di ambiente

const API_URL = 'https://apis-csvc-v0-2faa314f421f.herokuapp.com' // <<== da sostituire con variabile d'ambiente in .env
// const API_URL = 'http://localhost:5700' // <<== da sostituire con variabile d'ambiente in .env


let questionariArray = [];

export const SelezionaQuestionario = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
// ----------------------------------------------------------
//  INIZIO GESTIONE Modal CREA NUOVO QUESTIONARIO
  const [modalShow, setModalShow] = useState(false);

  const handleOpenModal = () => {
    setModalShow(true)
  }

  const handleCloseModal = () => {
    setModalShow(false)
  }
//  FINE GESTIONE Modal CREA NUOVO QUESTIONARIO
// ----------------------------------------------------------
// ----------------------------------------------------------
//  INIZIO GESTIONE Modal EDIT DETTAGLI QUESTIONARI
const [detailsModalShow, setDetailsModalShow] = useState(false);

const handleDetailsModalOpen = () => {
  setDetailsModalShow(true)
}

const handleDetailsModalClose = () => {
  setDetailsModalShow(false)
}
//  FINE GESTIONE Modal EDIT DETTAGLI QUESTIONARI
// ----------------------------------------------------------


//  INIZIO GESTIONE PER react-hook-form
  // const dispatch = useDispatch();
  const { control, handleSubmit,register, formState: { errors }  } = useForm({
    defaultValues: {nomeReferente: "", cognomeReferente: "", azienda: "", 
      userNameEmail: "", contattiReferente: "", 
      settoreMerceologicoCciaa: "", settoreDiAttivita: "", indirizzoSedeLegale: "", 
      sitoWeb: "", pec: ""
    }
  });

  const onSubmit = (updatedValues) => {
    /* 
    {
     nomeReferente: "Pippo", cognomeReferente: "Pluto", azienda: "Paperino S.p.A.", 
     userNameEmail: "topolino@mail.com", contattiReferente: "Tel. 335567890", 
     settoreMerceologicoCciaa: "ATECO 12345", settoreDiAttivita: "Gestione immobili", indirizzoSedeLegale: "via Tal dei Tali", 
     sitoWeb: "www.mipiaci.tu", pec: "mypec@cert.it" 
    }
    */
    console.log('Crea nuovo questionario - updatedValues: ', updatedValues)
    dispatch(creaNuovoQuestionario(updatedValues))
    setModalShow(false)
  };
//  FINE GESTIONE PER react-hook-form





  const handleAccediClicked = (QuestionarioUuidSelected) => {
    const questionarioSelected = questionariArray.filter(
      ({ questionarioUuid }) => questionarioUuid === QuestionarioUuidSelected
    );

    dispatch(
      setQuestionarioCorrente({
        questionarioUuid: questionarioSelected[0].questionarioUuid,
        aziendaNome: questionarioSelected[0].aziendaNome,
        noteQuestionario: questionarioSelected[0].noteQuestionario,
      })
    );
    dispatch(setPartnerPannelloEtQuestionario());

    // dispatch(setQuestionarioMenu());
    navigate('/app/questionario');
  };

  // 1°: Recupero csvcUuid e csvcRole da utenteCorrenteSlice
  const csvcUuid = useSelector(
    (state) => state.utenteCorrente.csvcUuid
  );
  const csvcRole = useSelector((state) => state.utenteCorrente.csvcRole);
  // console.log ('SelezionaQuestionario : ', csvcUuid, ' - ', csvcRole)

  // 2°: Richiedo al BackEnd tutti i questionari congruenti con csvcUuid e csvcRole for fetching an API on mount
////   const { data, status, error, numberOfItem } = useSelector( 
  const { data, status, error } = useSelector(
    (state) => state.elencoQuestionari
  );
  questionariArray = data;

  useEffect(() => {
    const endpoint = API_URL + '/questionari/elencoQuestionariByUserUuidAndUserRole/' +
    csvcUuid +
    '/' +
    csvcRole

    console.log (`elencoQuestionariByUserUuidAndUserRole ${endpoint}`)
    dispatch(   
      fetchElencoQuestionari( endpoint )
    );
  }, []);

  if (status === 'loading') {
    return <div className={`div-con-bordo`}>Caricamento questionari...</div>;
  } else if (status === 'succeded') {
////    if (numberOfItem == 0) {
////      return (
////        <div className={`div-con-bordo`}>Non sono presenti questionari</div>
////      );
////    } else if (numberOfItem == 1) {
////      // 3° - a:  Se ricevo un solo questionario, inizializzo questionarioCorrenteSlice con i
////      //          suoi dati generali e non renderizzo l'elenco dei questionari
////      handleAccediClicked(questionariArray[0].questionarioUuid);
////    } else {

      // 3° - b:  Se ricevo più di un questionario renderizzo l'elenco dei questionari.
//      const dispatch = useDispatch();
//      dispatch(unsetQuestionarioMenu())

      return (
        <>
          { (csvcRole==='partner'?<Button style={{marginBottom:"3%"}} variant="primary" onClick={handleOpenModal}>Crea nuovo questionario</Button>:'')}
          <div className="table-responsive scrollbar">
            <Table className="fs-10 mb-0 overflow-hidden table table-striped table-bordered">
              <thead className="bg-200 text-nowrap align-middle">
                <tr>
                  <th key="aziendaNome" className="fs-10 text-900">
                    Azienda
                  </th>
                  <th key="azione" className="fs-10"></th>
                  <th key="emailUsername" className="fs-10 text-900">
                    Username (email)
                  </th>
                  <th key="statoLavorazione" className="fs-10 text-900">
                    Stato
                  </th>
                  <th>
                  </th>
                </tr>
              </thead>
              <tbody>
                {questionariArray.map((questionario) => (
                  <tr
                    key={questionario.questionarioUuid}
                    className="align-middle white-space-nowrap"
                  >
                    <td key="aziendaNome" className="fs-10 text-900">
                      {questionario.aziendaNome}
                    </td>
                    <td key="azione">
                      <Button
                        variant="primary"
                        onClick={() =>
                          handleAccediClicked(questionario.questionarioUuid)
                        }
                      >
                        Accedi
                      </Button>
                    </td>
                    <td key="emailUsername" className="fs-10 text-900">
                      {questionario.emailUsername}
                    </td>
                    <td key="statoLavorazione" className="fs-10 text-900">
                      {questionario.statoLavorazione === 'L'
                        ? 'in lavorazione'
                        : questionario.statoLavorazione === 'C'
                        ? 'completato'
                        : questionario.statoLavorazione === 'A'
                        ? 'annullato'
                        : 'stato indefinito'}
                    </td>
                    <td>
                      <Button variant='secondary'  onClick={handleDetailsModalOpen}>
                        <BsPencil />
                      </Button>    
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <hr />
            <Modal size="lg" show={modalShow} onHide={handleCloseModal} backdrop="static" keyboard={false}>
              <Modal.Header>
                <Modal.Title>Crea nuovo questionario</Modal.Title>
                <FalconCloseButton onClick={handleCloseModal}/>
              </Modal.Header>

              <Modal.Body>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email del referente aziendale da usarsi come username per accedere all'area riservata (obbligatorio)</Form.Label>
                    <Controller
                        name="userNameEmail"
                        control={control}
                        defaultValue=""
                        rules={{
                            required: 'Questo campo è obbligatorio',
                            pattern: {
                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                message: 'Inserisci un indirizzo email valido'
                            }
                        }}
                        render={({ field }) => <Form.Control type="email" placeholder="Inserisci l'email del referente" {...field} />}
                    />
                    {errors.userNameEmail && <span style={{color:"red"}}>{errors.userNameEmail.message}</span>}
                </Form.Group>

                <Form.Group controlId="password">
                  <Form.Label>Password del referente aziendale (obbligatorio)</Form.Label>
                  <Controller
                    name="password"
                    control={control}
                    defaultValue={generaPassword()}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Inserisci la password del referente"
                        {...field}
                        {...register('password', {
                          required: 'Questo campo è obbligatorio',
                          validate: validatePassword
                        })}
                      />
                    )}
                  />
                  {errors.password && <span style={{color:"red"}}>{errors.password.message}</span>}
                </Form.Group>






                <Form.Group controlId="formNomeReferente" style={{marginTop:"2%"}}>
                    <Form.Label>Nome del referente (obbligatorio)</Form.Label>
                    <Controller
                    name="nomeReferente"
                    {...register('nomeReferente', { required:true})}
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci il nome del referente" {...field} />}
                    />
                    {errors.nomeReferente && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
                </Form.Group>

                <Form.Group controlId="formCognomeReferente" style={{marginTop:"2%"}}>
                    <Form.Label>Cognome del referente (obbligatorio)</Form.Label>
                    <Controller
                    name="cognomeReferente"
                    {...register('cognomeReferente', { required:true})}
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci il cognome del referente" {...field} />}
                    />
                    {errors.cognomeReferente && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
                </Form.Group>

                <Form.Group controlId="formAzienda" style={{marginTop:"2%"}}>
                    <Form.Label>Nome dell'azienda (obbligatorio)</Form.Label>
                    <Controller
                    name="azienda"
                    {...register('azienda', { required:true})}
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci il nome dell'azienda" {...field} />}
                    />
                    {errors.azienda && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
                </Form.Group>

                <hr /><hr />

                <Form.Group controlId="formContattiReferente" style={{marginTop:"2%"}}>
                    <Form.Label>Contatti del referente</Form.Label>
                    <Controller
                    name="contattiReferente"
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci i contatti del referente" {...field} />}
                    />
                </Form.Group>



                <Form.Group controlId="formSettoreMerceologicoCciaa" style={{marginTop:"2%"}}>
                    <Form.Label>Settore merceologico (come codificato da CCIAA)</Form.Label>
                    <Controller
                    name="settoreMerceologicoCciaa"
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci il Settore Merceologico (Cciaa)" {...field} />}
                    />
                </Form.Group>


                <Form.Group controlId="formSettoreDiAttivita" style={{marginTop:"2%"}}>
                    <Form.Label>Settore di attività</Form.Label>
                    <Controller
                    name="settoreDiAttivita"
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci il settore di attività dell'azienda" {...field} />}
                    />
                </Form.Group>

                <Form.Group controlId="formIndirizzoSedeLegale" style={{marginTop:"2%"}}>
                    <Form.Label>Indirizzo sede legale</Form.Label>
                    <Controller
                    name="indirizzoSedeLegale"
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci l'indirizzo della sede legale dell'azienda" {...field} />}
                    />
                </Form.Group>

                <Form.Group controlId="formSitoWeb" style={{marginTop:"2%"}}>
                    <Form.Label>Sito Web</Form.Label>
                    <Controller
                    name="sitoWeb"
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci il Sito Web dell'azienda" {...field} />}
                    />
                </Form.Group>

                <Form.Group controlId="formPec" style={{marginTop:"2%"}}>
                    <Form.Label>Pec</Form.Label>
                    <Controller
                    name="pec"
                    control={control}
                    defaultValue=""
                    render={({ field }) => <Form.Control type="text" placeholder="Inserisci la pec dell'azienda" {...field} />}
                    />
                </Form.Group>
                <Button style={{margin:"2%"}} variant="secondary" onClick={handleCloseModal}>Annulla</Button>
                <Button style={{margin:"2%"}} variant="primary" type="submit">Invia</Button>
                </Form>
                </Modal.Body>
              <Modal.Footer>
              </Modal.Footer>
            </Modal>

            {/* =========================================================================================================== */}

            <Modal size="lg" show={detailsModalShow} onHide={handleDetailsModalClose} backdrop="static" keyboard={false}>
              <Modal.Header>
                <Modal.Title>Modifica stato questionario</Modal.Title>
                <FalconCloseButton onClick={handleDetailsModalClose}/>
              </Modal.Header>

              <Modal.Body>
              <Form >
                <p>Questa area è predisposta per modificare lo stato del questionario da "In lavorazione" a "completato" o "annullato" in funzione delle policy che verranno definite.</p>
                <Button style={{margin:"2%"}} variant="secondary" onClick={handleDetailsModalClose}>Annulla</Button>
                <Button style={{margin:"2%"}} variant="primary" onClick={handleDetailsModalClose}>Invia</Button>
                </Form>
                </Modal.Body>
              <Modal.Footer>
              </Modal.Footer>
            </Modal>


        </>
      );
////    }
  } else if (status === 'failed') {
    return (
      <div className={`div-con-bordo`}>
        Si è verificata la seguente eccezione: {error}
      </div>
    );
  } else {
    return (
      <div className={`div-con-bordo`}>
        Si è verificata la seguente eccezione: Stato {status}
      </div>
    );
  }
};
